export type EtfRegion = 'KR' | 'US';
export type EtfStyle = 'growth' | 'income' | 'covered-call';

export interface DividendEtf {
  id: string;
  ticker: string;
  name: string;
  nameEn: string;
  region: EtfRegion;
  taxRate: number;
  dividendYield: number;
  dividendGrowthRate: number;
  capitalGrowthRate: number;
  frequency: 'monthly' | 'quarterly';
  style: EtfStyle;
  description: string;
  pros: string;
  cons: string;
}

export const DIVIDEND_ETFS: DividendEtf[] = [
  {
    id: 'tiger-us-dividend',
    ticker: 'TIGER 미국배당다우존스',
    name: 'TIGER 미국배당다우존스',
    nameEn: 'TIGER US Dividend',
    region: 'KR',
    taxRate: 0.154,
    dividendYield: 0.038,
    dividendGrowthRate: 0.07,
    capitalGrowthRate: 0.085,
    frequency: 'monthly',
    style: 'growth',
    description: '미국 배당성장주 월배당 ETF. SCHD 벤치마크 추종.',
    pros: '월배당, 배당성장 이력 우수, 원화 투자 가능',
    cons: '환율 위험 내재, 배당수익률은 낮은 편',
  },
  {
    id: 'kodex-us-dividend-premium',
    ticker: 'KODEX 미국배당프리미엄',
    name: 'KODEX 미국배당프리미엄',
    nameEn: 'KODEX US Dividend Premium',
    region: 'KR',
    taxRate: 0.154,
    dividendYield: 0.065,
    dividendGrowthRate: 0.02,
    capitalGrowthRate: 0.04,
    frequency: 'monthly',
    style: 'covered-call',
    description: '미국 배당주 + 커버드콜 전략. 높은 배당수익률.',
    pros: '높은 배당수익률, 월배당, 원화 투자',
    cons: '커버드콜로 주가 상승 참여 제한, 배당성장 낮음',
  },
  {
    id: 'tiger-us-dividend-plus3',
    ticker: 'TIGER 미국배당+3%프리미엄',
    name: 'TIGER 미국배당+3%프리미엄',
    nameEn: 'TIGER US Dividend+3% Premium',
    region: 'KR',
    taxRate: 0.154,
    dividendYield: 0.075,
    dividendGrowthRate: 0.015,
    capitalGrowthRate: 0.03,
    frequency: 'monthly',
    style: 'covered-call',
    description: '배당+커버드콜로 연 7~8% 배당수익률 목표.',
    pros: '높은 현금 흐름, 월배당',
    cons: '자본 성장 제한, 장기 실질 수익 낮을 수 있음',
  },
  {
    id: 'kodex-dividend-growth',
    ticker: 'KODEX 배당성장',
    name: 'KODEX 배당성장',
    nameEn: 'KODEX Dividend Growth',
    region: 'KR',
    taxRate: 0.154,
    dividendYield: 0.028,
    dividendGrowthRate: 0.08,
    capitalGrowthRate: 0.09,
    frequency: 'quarterly',
    style: 'growth',
    description: '국내 배당성장주 ETF. 장기 배당 증가에 초점.',
    pros: '배당성장 잠재력, 국내 주식 환율 리스크 없음',
    cons: '배당수익률 낮음, 분기 배당',
  },
  {
    id: 'schd',
    ticker: 'SCHD',
    name: 'Schwab 미국 배당주 ETF',
    nameEn: 'SCHD',
    region: 'US',
    taxRate: 0.15,
    dividendYield: 0.035,
    dividendGrowthRate: 0.1,
    capitalGrowthRate: 0.1,
    frequency: 'quarterly',
    style: 'growth',
    description: '미국 배당성장 ETF의 대표. 10년+ 배당 증가 기업 편입.',
    pros: '최고 수준의 배당성장 이력, 낮은 운용보수',
    cons: '해외 직투 필요, 환율 리스크, 분기 배당',
  },
  {
    id: 'vym',
    ticker: 'VYM',
    name: 'Vanguard 고배당주 ETF',
    nameEn: 'VYM',
    region: 'US',
    taxRate: 0.15,
    dividendYield: 0.028,
    dividendGrowthRate: 0.06,
    capitalGrowthRate: 0.09,
    frequency: 'quarterly',
    style: 'growth',
    description: '광범위한 고배당 미국 주식 포트폴리오. 분산 우수.',
    pros: '광범위한 분산, 안정적 배당',
    cons: '배당 성장률은 SCHD 대비 낮음',
  },
  {
    id: 'jepi',
    ticker: 'JEPI',
    name: 'JPMorgan 프리미엄 소득 ETF',
    nameEn: 'JEPI',
    region: 'US',
    taxRate: 0.15,
    dividendYield: 0.075,
    dividendGrowthRate: 0.01,
    capitalGrowthRate: 0.04,
    frequency: 'monthly',
    style: 'covered-call',
    description: '커버드콜 + S&P500 배당주. 높은 월배당 소득.',
    pros: '월배당, 높은 현금 흐름, 변동성 완충',
    cons: '배당 변동성 있음, 자본 성장 제한',
  },
  {
    id: 'vig',
    ticker: 'VIG',
    name: 'Vanguard 배당성장 ETF',
    nameEn: 'VIG',
    region: 'US',
    taxRate: 0.15,
    dividendYield: 0.018,
    dividendGrowthRate: 0.1,
    capitalGrowthRate: 0.11,
    frequency: 'quarterly',
    style: 'growth',
    description: '10년 이상 연속 배당 증가 기업만 편입. 장기 성장.',
    pros: '최고 수준 배당성장, 주가 상승 참여',
    cons: '배당수익률 낮음, 장기 보유 필요',
  },
];

export interface DividendFormValues {
  etfId: string;
  initialInvestment: number;
  monthlyAddition: number;
  years: number;
  drip: boolean;
}

export interface DividendYearlyDataPoint {
  year: number;
  totalValue: number;
  principal: number;
  annualGrossDividend: number;
  annualNetDividend: number;
  cumulativeNetDividend: number;
  yoc: number;
}

export interface DividendResult {
  etf: DividendEtf;
  yearlyData: DividendYearlyDataPoint[];
  finalTotalValue: number;
  finalAnnualNetDividend: number;
  finalMonthlyNetDividend: number;
  finalYoc: number;
  totalInvested: number;
  totalNetDividendReceived: number;
}

export function simulateDRIP(
  etf: DividendEtf,
  values: DividendFormValues
): DividendYearlyDataPoint[] {
  const { initialInvestment, monthlyAddition, years, drip } = values;
  const annualAddition = monthlyAddition * 12;

  let portfolioValue = initialInvestment;
  let cumulativeNetDividend = 0;
  const data: DividendYearlyDataPoint[] = [];

  for (let year = 1; year <= years; year += 1) {
    portfolioValue += annualAddition;
    const principal = initialInvestment + annualAddition * year;

    const currentYield = etf.dividendYield * Math.pow(1 + etf.dividendGrowthRate, year - 1);
    const annualGrossDividend = Math.round(portfolioValue * currentYield);
    const annualNetDividend = Math.round(annualGrossDividend * (1 - etf.taxRate));

    if (drip) {
      portfolioValue += annualNetDividend;
    } else {
      cumulativeNetDividend += annualNetDividend;
    }

    portfolioValue = Math.round(portfolioValue * (1 + etf.capitalGrowthRate));

    data.push({
      year,
      totalValue: portfolioValue,
      principal,
      annualGrossDividend,
      annualNetDividend,
      cumulativeNetDividend: drip ? 0 : cumulativeNetDividend,
      yoc: principal > 0 ? (annualNetDividend / principal) * 100 : 0,
    });
  }

  return data;
}

export function calculateDividendResult(values: DividendFormValues): DividendResult {
  const etf = DIVIDEND_ETFS.find((item) => item.id === values.etfId) ?? DIVIDEND_ETFS[0];
  const yearlyData = simulateDRIP(etf, values);
  const last = yearlyData[yearlyData.length - 1];

  return {
    etf,
    yearlyData,
    finalTotalValue: last.totalValue,
    finalAnnualNetDividend: last.annualNetDividend,
    finalMonthlyNetDividend: Math.round(last.annualNetDividend / 12),
    finalYoc: last.yoc,
    totalInvested: last.principal,
    totalNetDividendReceived: last.cumulativeNetDividend,
  };
}

export interface EtfCompareRow {
  etf: DividendEtf;
  monthlyNetDividendAt10y: number;
  monthlyNetDividendFinal: number;
  finalTotalValue: number;
  yocFinal: number;
}

export function buildEtfCompareRows(values: DividendFormValues): EtfCompareRow[] {
  return DIVIDEND_ETFS.map((etf) => {
    const dataAt10y = simulateDRIP(etf, { ...values, etfId: etf.id, years: Math.min(10, values.years) });
    const dataAtFull = simulateDRIP(etf, { ...values, etfId: etf.id });
    const last10 = dataAt10y[dataAt10y.length - 1];
    const lastFull = dataAtFull[dataAtFull.length - 1];

    return {
      etf,
      monthlyNetDividendAt10y: Math.round(last10.annualNetDividend / 12),
      monthlyNetDividendFinal: Math.round(lastFull.annualNetDividend / 12),
      finalTotalValue: lastFull.totalValue,
      yocFinal: lastFull.yoc,
    };
  });
}

export function getDividendCallout(result: DividendResult) {
  const { etf, finalMonthlyNetDividend, finalYoc } = result;

  if (etf.style === 'covered-call') {
    return {
      title: '커버드콜 ETF는 현금 흐름은 많지만 자본 성장이 제한됩니다',
      body: '높은 배당수익률은 매력적이지만, 커버드콜 전략은 주가 상승 시 수익 참여가 제한됩니다. 인출 시기가 10년 이내라면 적합하지만, 20년 이상 장기라면 배당성장형 ETF와 병행을 권장합니다.',
      cta: { label: '복리 시뮬레이터로 성장형 vs 소득형 비교', href: '/compound' },
    };
  }

  if (finalMonthlyNetDividend < 500_000) {
    return {
      title: '목표 월 배당금에 도달하려면 납입액을 늘리거나 기간을 연장하세요',
      body: '월 50만 원 이상의 배당 소득을 만들려면 복리 기간이 길수록 유리합니다. 초기 투자금 확대 또는 납입 기간 연장이 가장 효과적인 방법입니다.',
      cta: { label: '목표 설계 계산기로 납입액 역산', href: '/retirement/goal' },
    };
  }

  if (finalYoc > 8) {
    return {
      title: `투자 원금 대비 ${finalYoc.toFixed(1)}% 배당 — 강력한 현금 흐름입니다`,
      body: '오랜 기간 배당 재투자를 지속하면 초기 투자금 대비 실질 수익률(YOC)이 크게 올라갑니다. 지금의 낮아 보이는 배당률이 복리로 얼마나 성장하는지 확인하세요.',
      cta: { label: 'ISA·IRP로 배당세 절세하기', href: '/tax-benefit' },
    };
  }

  return {
    title: '배당 ETF는 노후 현금 흐름의 핵심 자산입니다',
    body: '배당 재투자(DRIP)를 통한 복리 효과를 극대화하세요. ISA 계좌 내에서 운용하면 배당소득세도 절약할 수 있습니다.',
    cta: { label: 'ISA·IRP 절세 효과 계산하기', href: '/tax-benefit' },
  };
}
